module.exports = __webpack_public_path__ + "static/media/repository.118d124d.svg";